import React, { useEffect, useState, useContext, useCallback, useMemo } from "react";
import { useParams, useNavigate } from "react-router";
import useFoodMenu from "../../hooks/useFoodMenu";
import { HotelContext } from "../../context/hotel";
import { UserContext } from "../../context/user";
import { Modal, Button, Spinner } from "react-bootstrap";
import Screen from "../../components/Screen";
import { T, TF } from "react-translator-component";
import { i18nValue, parsePreferences } from "../../functions";
import CartItem from "../../components/CartComponents/CartItem";
import {
    Col,
    Row,
    Container
  } from "react-bootstrap";
import CartButtons from "../../components/CartComponents/CartButtons";
import { currencyFormat } from "../../functions";
import PublicCartSummary from "./PublicCartSummary";
import { usePerson, publicBookablePersonSchema } from "../../context/person";
import '../../scss/_public_cart.scss';
import { useHourDisabled } from "../../hooks/useHourDisabled";
import PaymentMethod from "../../components/PaymentMethod";
import { formatAvailableHours } from "../../functions";
import ReactHtmlParser from "react-html-parser";
import { useLanguage } from "../../hooks/useLanguage";

const PublicCart = () => {
    const { getFoodMenu } = useFoodMenu();
    const { sectionsByCode, currency } = useContext(HotelContext);
    const { language, requestCreate } = useContext(UserContext);
    const [menu, setMenu] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { data: person, setData: setPerson } = usePerson();
    const [showCoverHourDisabled, setShowCoverHourDisabled] = useState('');
    const { validateHourDisabled } = useHourDisabled('public_cart');
    const isDisabled = useMemo(() => {
      return sectionsByCode?.public_cart?.extras?.scheduleConfig?.mode == 'disabled';
    }, []);
 
    useEffect(() => {
      setShowCoverHourDisabled(validateHourDisabled);
    }, [validateHourDisabled]);

    useEffect(() => {
        if (sectionsByCode?.public_cart?.extras?.foodMenuId && !isDisabled && !showCoverHourDisabled) {
            setLoading(true);
            getFoodMenu(undefined, sectionsByCode["public_cart"].extras.foodMenuId)
            .then((r) => {
                console.log('19dic - Respuesta cruda de getFoodMenu:', r);
                setMenu(r);
                setLoading(false);
            //   if (!r || !r.content || !Array.isArray(r.content) || r.content.length === 0 || r.content.every(section => !section.items || section.items.length === 0)) {
            //     console.log('getFoodMenu Fail!')
            //     setLoadItemsError(T("menu.items_not_found")); // Mensaje de error más general
            //     setMenu(null);
            //   } else {
            //     console.log('Setting getFoodMenu')
            //     setMenu(r);
            //     setLoadItemsError("");
            //   }
            })
            .catch((response) => {
                console.error('19dic - Error on load items:', response);
                setError('Error al cargar el menú');
                setLoading(false);
            });
        } else {
            setError('No hay carta seleccionada');
            setLoading(false);
        }
    }, []);
    
    return (
        <Screen
            section="public_cart"
            title={i18nValue(sectionsByCode?.public_cart, 'title', language)}
            classes="public-cart"
        >
            {loading && !showCoverHourDisabled && (
              <div className="cart-spinner">
                <div
                  className="spinner-border"
                  role="status"
                ></div>
              </div>
            )}
            {error && !isDisabled && !showCoverHourDisabled && <div>Error: {error}</div>}
            {menu && !isDisabled && !showCoverHourDisabled && <div>
                <MenuComponent 
                    menu={menu} 
                    language={language} 
                    currency={currency} 
                    requestCreate={requestCreate}
                    person={person}
                />
            </div>}
            {isDisabled && <div className="mt-4">
              <p className="cover-hour-disabled">{ReactHtmlParser(i18nValue({disableReasonI18n: sectionsByCode?.public_cart?.extras?.scheduleConfig?.disableReason}, 'disableReason', language))}</p>
            </div>}
            {showCoverHourDisabled && <div className="mt-4 availability-section">
              <p className="cover-hour-disabled">{T(showCoverHourDisabled)}</p>
              {(() => {
                const hoursData = formatAvailableHours(
                  sectionsByCode?.public_cart?.extras?.scheduleConfig?.startHour,
                  sectionsByCode?.public_cart?.extras?.scheduleConfig?.endHour,
                  sectionsByCode?.public_cart?.extras?.scheduleConfig?.unavailableSlots,
                  sectionsByCode?.public_cart?.extras?.scheduleConfig?.duration
                );
                return (
                  <div className="available-hours-container">
                    <div className="day-name">{T(`days.${hoursData.dayName}`)}</div>
                    <p className="hours-label">({T('public_cart.hours-label')})</p>
                    <div className="hours-list">
                      {hoursData.availableRanges.map((range, idx) => (
                        <div key={idx} className="hour-range">{range}</div>
                      ))}
                    </div>
                  </div>
                );
              })()}
            </div>}
        </Screen>
    )
};

const cartEmpty = {
    qty: 0,
    total: 0,
    desc: "",
    items: [],
};

const MenuComponent = ({ menu, language, currency, requestCreate, person }) => {
    const isMenuWithTabs = true;
    const [searchTerm, setSearchTerm] = useState("");
    const [activeCategoryIndex, setActiveCategoryIndex] = useState(0);
    const [data, setData] = useState({});
    const [cart, setCart] = useState(cartEmpty);
    const [showFloatCart, setShowFloatCart] = useState(false);
    const [summary, setSummary] = useState(false);
    const [confirmToRequest, setConfirmToRequest] = useState(true);
    const [listItemsArray, setListItemsArray] = useState([]);
    const [cartItemsCustomizations, setCartItemsCustomizations] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [observations, setObservations] = useState(null);
    const [showCustomizationMessages, setShowCustomizationMessages] = useState({});
    const [isProcessing, setIsProcessing] = useState(false);
    const [paymentOptions, setPaymentOptions] = useState([]);
    const [requestId, setRequestId] = useState(null);
    const navigate = useNavigate();
    const { data: hotel } = useContext(HotelContext);
    const { defaultLanguage } = useLanguage();
    const handleBackToRequestDetail = () => {
        navigate(`/${hotel?.code}/public/requests/${requestId}`, { replace: true });
    }
    const handleCartReset = () => {
        setData({ items: {} });
        setCart({ qty: 0, total: 0, desc: "", items: [] });
        setShowFloatCart(false);
        setSummary(false);
        setObservations(null);
        setCartItemsCustomizations(null);
        setShowCustomizationMessages({});
    };

    useEffect(() => {
        console.log('19dic - data', data);
        let _itemsArray = menu?.content.flatMap(i => i.items)
        setListItemsArray(_itemsArray);
    }, [ menu ]);

    useEffect(() => {
        const _cart = { 
            qty: 0,
            total: 0,
            desc: "",
            items: []
        };
        const _desc = [];
        let totalQty = 0;

        if (data?.items && listItemsArray && listItemsArray.length > 0) {
            Object.keys(data.items).forEach((itemId) => {
                const quantity = data.items[itemId];
                
                // Solo procesar si la cantidad es mayor a 0
                if (quantity > 0) {
                    const product = listItemsArray.find((item) => item.id === itemId);
                    
                    if (product) {
                        const _name = i18nValue(product, "name", language) || product.name;
                        const _description = i18nValue(product, "description", language) || product.description;

                        _cart.items.push({
                            itemId: product?.id,
                            name: _name,
                            type: product?.type,
                            desc: _description,
                            price: product?.price,
                            vat: product?.vat,
                            account: product?.account,
                            preferences: parsePreferences(product?.preferences),
                            subAccount: product?.subAccount,
                            qty: quantity,
                            total: parseFloat((product?.price * quantity).toFixed(2)),
                        });
                        _desc.push(quantity + "x" + _name);
                        totalQty += quantity;
                        _cart.total += parseFloat((product?.price * quantity).toFixed(2));
                    }
                }
            });
        }
        _cart.qty = totalQty;
        _cart.desc = _desc.join(", ");
    
        console.log('PublicCart - Carrito actualizado:', _cart);
        setCart(_cart);
        setShowFloatCart(_cart.items && _cart.items.length > 0);
    
    }, [data, listItemsArray, language]);

    const handleDeleteItem = (itemId) => {
      const updatedDataItems = { ...data.items };
      updatedDataItems[itemId] = (updatedDataItems[itemId] ?? 0) - 1;
      
      // Asegurar que nunca sea negativo
      if (updatedDataItems[itemId] < 0) {
        updatedDataItems[itemId] = 0;
      }
  
      setData({
        ...data,
        items: updatedDataItems
      });
  
      // Manejo de mostrar/ocultar mensajes de personalización
      if (updatedDataItems[itemId] > 0) {
        setShowCustomizationMessages(prevState => ({
          ...prevState,
          [itemId]: true
        }));
      } else {
        setShowCustomizationMessages(prevState => ({
          ...prevState,
          [itemId]: false
        }));
      }
      
      // Si el carrito queda vacío, cerrar el resumen
      if (cart.qty <= 1) {
        setSummary(false);
      }
    };

    const onSave = useCallback(() => {
        setIsProcessing(true);
        const _data = { ...data }
        let _cart = {}
        _cart = { ...cart }
        delete (_cart.desc)
        _cart.items = _cart.items.map((item) => {
            delete (item.name)
            delete (item.preferences)
            delete (item.desc)
            if (cartItemsCustomizations && cartItemsCustomizations[item.itemId]) {
                item.customizations = Object.values(cartItemsCustomizations[item.itemId]);
            }
            return item;
        })

        const payload = {
            // hotelId: hotel.id,
            // roomOccupationId: RoomOccupation.id,
            client: {
                name: person?.fullname || "",
                email: person?.email || "",
                phone: person?.phone || "",
                fullname: person?.fullname || "",
            },
            type: "items_sales",
            // subType: "public_cart",
            data: JSON.stringify(_data),
            cart: JSON.stringify(_cart),
            deliveryPoint: `${person?.location || ""}-${person?.tent || ""}`,
            observations: observations || ""
        };
        console.log('07 ene - payload', payload);
        requestCreate(payload)
            .then((response) => {
                setIsProcessing(true);
                setRequestId(response?.requestId);
                if (response?.paymentUrl) {
                    window.location.href = response.paymentUrl;
                } else if (response?.paymentOptions) {
                  setPaymentOptions(response.paymentOptions)
                } else {
                    console.log('23dic - requestCreate success', response);
                }
            })
            .catch((response) => {
                setIsProcessing(false);
                console.log("error", response);
            });

    }, [ cart, person, observations, cartItemsCustomizations ]);

    const handleCartAddButtonClick = (id) => {
        // handleAddButtonClick(id);
        const _items = { ...data.items };
        _items[id] = (_items[id] ?? 0) + 1;
        setData({
          ...data,
          items: _items,
        });
    }
    const handleCartDeleteButtonClick = (id) => {
        // handleDeleteItem(id);
        const _items = { ...data.items };
        _items[id] = (_items[id] ?? 0) - 1;
        _items[id] = _items[id] >= 0 ? _items[id] : 0;
        setData({
          ...data,
          items: _items,
        });
    }

    const filterItems = (items) => {
        if (!searchTerm) return items;
        return items.filter(item => {
          const name = i18nValue(item, "name", language) || item.name || "";
          const desc = i18nValue(item, "description", language) || item.description || "";
          return (
            name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            desc.toLowerCase().includes(searchTerm.toLowerCase())
          );
        });
    };

    return (
        <>
        {isMenuWithTabs && (
            <div className="menu-header mt-3">
              <input
                type="text"
                className="form-control input-menu-search mb-3"
                placeholder={T("menu.search")}
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
              />
              <div className="categories-buttons">
                <button
                  key={-1}
                  type="button"
                  className={`btn btn-sm category-btn ${activeCategoryIndex === 0 ? 'btn-secondary active' : 'btn-outline-secondary inactive'}`}
                  onClick={() => setActiveCategoryIndex(0)}
                >
                  {T("menu.all")}
                </button>
                {menu.content.map((section, idx) => (
                  <button
                    key={idx + 1}
                    type="button"
                    className={`btn btn-sm category-btn ${activeCategoryIndex === idx + 1 ? 'btn-secondary active' : 'btn-outline-secondary inactive'}`}
                    onClick={() => setActiveCategoryIndex(idx + 1)}
                  >
                    {i18nValue(section, "title", language, null, null, defaultLanguage()) || TF("menu.category", [idx + 1])}
                  </button>
                ))}
              </div>
            </div>
        )}

        <div className="section-card" key={-1}>
            {menu.content.map((section, idx) => {
              // Muestra las categorias de acuerdo al filtro aplicado (botón)
                if (activeCategoryIndex !== 0 && activeCategoryIndex !== idx + 1) {
                    return null;
                }
                return (
                    <div key={idx}>
                    {section.items && filterItems(section.items).map((item, itemIndex) => {
                        if (item) {
                            return (
                              <>
                                {itemIndex === 0 && (
                                  <>
                                    <h6 className="section-title">{i18nValue(section, "title", language)}</h6>
                                    <p className="section-description">{i18nValue(section, "description", language)}</p>
                                  </>
                                )}
                                <CartItem
                                    key={`section-item-${item.id}`}
                                    item={item}
                                    value={data["items"] !== undefined ? data["items"][item.id] ?? 0 : 0}
                                    language={language}
                                    currency={currency}
                                    showImages={true}
                                    showCustomizationMessages={true}
                                    handleAddButtonClick={handleCartAddButtonClick}
                                    handleDeleteItem={handleCartDeleteButtonClick}
                                    cartAvailavility={true}
                                    hideOnDisabled={false}
                                />
                             </>)
                        }
                       })}
                  </div>
                );
            })}
        </div>
      
        {summary && cart.items.length > 0 && (
          <>
                    <PublicCartSummary
                      cart={cart}
                      summary={summary}
                      setSummary={setSummary}
                      // setMenuObservation={setMenuObservation}
                      // selectedOptions={selectedOptions}
                      // setSelectedOptions={setSelectedOptions}
                      setCartItemsCustomizations={setCartItemsCustomizations}
                      setConfirmToRequest={setConfirmToRequest}
                      setOpenModal={setOpenModal}
                      observations={observations}
                      setObservations={setObservations}
                      language={language}
                      handleDeleteItem={handleDeleteItem}
                      // isEdit={requestId}
                    />
                  </>
                  )}
        {showFloatCart &&
                    <div className="cart-container">
                      <Container>
                      <Row>
                        <Col xs={6}>
                          <div className="mt-1 py-2">
                            <span className="cart-title">{T("request.your-request")}</span>
                            <small className="text-muted">{` (${cart.qty} ${cart.qty > 1 ? T("request.products") : T("request.product")})`}</small>
                          </div>
                          <span className="cart-description">{cart.desc}</span>
                        </Col>
                        <Col xs={6} className="cart-price pt-2">
                          <div>{currencyFormat(cart.total, currency)}</div>
                        </Col>
                      </Row>
                      <CartButtons
                        setSummary={setSummary}
                        onSave={onSave}
                        confirmToRequest={confirmToRequest}
                        cartReset={handleCartReset}
                        cart={cart}
                      />
                      </Container>
                    </div>}
          

        <Modal show={openModal} centered backdrop="static" onHide={() => !isProcessing && setOpenModal(false)}>
          <Modal.Header style={{
            display: isProcessing ? "none" : "flex",
          }} className="modal-header-center">
            <Modal.Title className="ms-auto">
              <span className="modal-title-text">
                {T("services.confirm-request")}
              </span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Footer style={{
            display: isProcessing ? "none" : "flex",
          }} className="modal-footer-spaced">
            <div>
              <small className={`modal-back-link ${isProcessing ? 'disabled' : ''}`} onClick={() => !isProcessing && setOpenModal(false)}>
                {T("general.back")}
              </small>
            </div>
            <Button variant="success" onClick={onSave} disabled={isProcessing}>
              {T("general.confirm")}
            </Button>
          </Modal.Footer>
          {paymentOptions.length > 0 && (
            <Modal.Footer className="text-center">
              <h5 className="mb-2 w-100">{T("general.payment-method")}</h5>
              <PaymentMethod
                requestId={requestId}
                paymentOptions={paymentOptions}
              />
               <div>
                {/* tiene que ir al  request detail*/}
              <small className={`modal-back-link`} onClick={handleBackToRequestDetail}>
                {T("general.close")}
              </small>
            </div>
            </Modal.Footer>
          )}
          {isProcessing && paymentOptions.length === 0 && (
            <div style={{ height: 150, paddingTop: 30 }}>
              <div className="processing-modal text-center">
                <div style={{ display: 'flex', justifyContent: 'center', padding: '10px' }}>
                    <Spinner animation="border" />
                </div>
                <p className="processing-text">
                  {T('general.processing-request')}
                </p>
              </div>
            </div>
          )}
        </Modal>
      </>
    )
}

export default PublicCart;

